module.exports = __webpack_public_path__ + "img/hotel-icon.974e8d1d.png";